var _a;
import { RAW_STRING } from "./constants.js";
export class RawString {
    constructor(val) {
        // Used to detect whether a value is a RawString object rather than using an instanceof check
        this[_a] = true;
        this.val = val;
    }
    /**
     * Returns the content of the RawString object as a simple string
     */
    toString() {
        return this.val;
    }
    toJSON() {
        return this.val;
    }
}
_a = RAW_STRING;
